module.exports = __webpack_public_path__ + "img/500.4ed4765.svg";